import { FC, memo } from 'react';
import s from './Button.module.scss';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  ref?: React.RefObject<HTMLButtonElement>;
  isAccent?: boolean;
  isRounded?: boolean;
};

export const Button: FC<ButtonProps> = memo(
  ({
    type,
    children,
    className,
    onClick,
    ref,
    isAccent = false,
    isRounded = false,
    ...props
  }) => {
    return (
      <button
        ref={ref}
        type={type || 'button'}
        className={`${s.btn} ${className ?? ''}`}
        onClick={onClick}
        data-accent={isAccent}
        data-rounded={isRounded}
        {...props}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
